/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_To_Json_Ref_N1Inputs */

const en_csv_to_json_ref_n1 = /** @type {(inputs: Csv_To_Json_Ref_N1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A quoted field keeps its comma. The comma does not split the field.`)
};

const ko_csv_to_json_ref_n1 = /** @type {(inputs: Csv_To_Json_Ref_N1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`인용된 필드는 쉼표를 유지합니다. 쉼표가 필드를 쪼개지 않습니다.`)
};

const ja_csv_to_json_ref_n1 = /** @type {(inputs: Csv_To_Json_Ref_N1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`引用されたフィールドはカンマを保ちます。カンマがフィールドを分割しません。`)
};

/**
* | output |
* | --- |
* | "A quoted field keeps its comma. The comma does not split the field." |
*
* @param {Csv_To_Json_Ref_N1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const csv_to_json_ref_n1 = /** @type {((inputs?: Csv_To_Json_Ref_N1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_To_Json_Ref_N1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_csv_to_json_ref_n1(inputs)
	if (locale === "ko") return ko_csv_to_json_ref_n1(inputs)
	return ja_csv_to_json_ref_n1(inputs)
});